import React from 'react';
import {observable, action, makeObservable} from 'mobx';
import {observer} from 'mobx-react';
import store from '../../s';
import ShipMethods from './shipMethods';
import {checkout} from '../../../api';
import ShippingAddrEdit from './shippingAddrEdit';
import ShippingCorrection from './shippingCorrection';
import {currency, isNullOrWhiteSpace, Portal} from '../../../util';

declare var modalOpen: any;

@observer
export class ShippingAddrReadOnly extends React.Component<{hideEdit: boolean}> {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="row shipping-read-only gray">
                <div className="col-12 col-lg-6">
                    <div className="black">
                        <span className="form-label form-label-light ship-label-3">Shipping Address</span>
                        {!this.props.hideEdit && !store.uiCheckout.processing && (
                            <button
                                className="link text-btn b pointer"
                                style={{marginLeft: 12}}
                                onClick={() => store.moveStep(ICheckoutStep.shipping)}
                                type="button"
                                aria-label="Edit shipping address"
                            >
                                edit
                            </button>
                        )}
                    </div>
                    <div className="">
                        {store.checkout.ship.addr.firstName.value}&nbsp;
                        {store.checkout.ship.addr.lastName.value}
                    </div>
                    {!isNullOrWhiteSpace(store.checkout.ship.addr.companyName.value) && store.checkout.ship.addressType === ICheckoutAddressType.business && <div className="">{store.checkout.ship.addr.companyName.value}</div>}
                    <div className="">{store.checkout.ship.addr.address1.value}</div>
                    {!isNullOrWhiteSpace(store.checkout.ship.addr.address2.value) && <div className="">{store.checkout.ship.addr.address2.value}</div>}
                    {!isNullOrWhiteSpace(store.checkout.ship.addr.address3.value) && <div className="">{store.checkout.ship.addr.address3.value}</div>}
                    {!isNullOrWhiteSpace(store.checkout.ship.addr.address4.value) && <div className="">{store.checkout.ship.addr.address4.value}</div>}
                    <div className="">
                        {store.checkout.ship.addr.city.value}
                        {store.checkout.ship.addr.state.value.length > 0 && (
                            <span>
                                ,&nbsp;
                                {store.checkout.ship.addr.state.value.startsWith('AE') ? 'AE' : store.checkout.ship.addr.state.value}
                            </span>
                        )}
                        &nbsp;{store.checkout.ship.addr.postalCode.value}&nbsp;
                        {store.checkout.ship.addr.country.value}
                    </div>
                    <div>{store.checkout.ship.addr.isBusinessAddress === true ? 'Business Address' : 'Residential Address'}</div>
                </div>
                {store.checkout.cstep > ICheckoutStep.shipping_methods && (
                    <div className="col-12 col-lg-6 hidden-xs hidden-sm hidden-md">
                        <div
                            className="ship-options-read gray"
                            style={{paddingTop: 0}}
                        >
                            <div className="row">
                                <div className="col-12">
                                    <div className="form-label form-label-light ship-label-3 mt-2">Shipping Method</div>
                                    {(!store.checkout.isMyFrames || store.checkout.myframes_isDropShip) && (
                                        <div>
                                            {store.checkout.ship.shipMethod.desc} {currency(store.checkout.ship.shipMethod.price_production + store.checkout.ship.shipMethod.price_shipping)}
                                        </div>
                                    )}
                                    {(!store.checkout.isMyFrames || store.checkout.myframes_isDropShip) && <div className="black b">Get it by {store.checkout.ship.shipMethod.dates}</div>}
                                    {store.checkout.isMyFrames && !store.checkout.myframes_isDropShip && <div className="black b">Fedex Ground or my pre-determined shipping method</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

@observer
class OrderNotes extends React.Component {
    @observable editNoteGift: boolean;
    @observable editNoteOrder: boolean;

    constructor(props) {
        super(props);
        this.addGiftMessage = this.addGiftMessage.bind(this);
        this.changeGiftMessage = this.changeGiftMessage.bind(this);
        makeObservable(this);
    }

    @action
    addGiftMessage = (e: any) => {
        this.editNoteGift = true;
        this.editNoteOrder = false;
    };

    @action
    addOrderNote = (e: any) => {
        this.editNoteGift = false;
        this.editNoteOrder = true;
    };

    @action
    changeGiftMessage = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const giftMessageId: number = parseInt(e.target.value, 10);
        store.checkout.notes_gift = giftMessageId === 7 ? '' : store.checkout.giftMessages.filter(o => o.GiftMessageID === giftMessageId)[0].GiftMessage;
        store.checkout.giftMessageId = giftMessageId;
    };

    @action
    saveNotes = async (e: any) => {
        const success = await checkout('notes-save');
        this.editNoteGift = false;
        this.editNoteOrder = false;
    };

    render() {
        return (
            <div>
                {!this.editNoteOrder && store.checkout.notes_customer.length > 0 && (
                    <div className="row">
                        <div className="col-12 mt-2">
                            <span className="b">Order Notes: </span>
                            {store.checkout.notes_customer}
                            <span className="pad-left">
                                <span
                                    className="link b pointer"
                                    onClick={this.addOrderNote}
                                >
                                    Edit
                                </span>
                            </span>
                        </div>
                    </div>
                )}

                {!this.editNoteGift && store.checkout.notes_gift.length > 0 && (
                    <div className="row">
                        <div className="col-12 mt-2">
                            <span className="b">Gift Message: </span>
                            {store.checkout.notes_gift}
                            <span className="pad-left">
                                <span
                                    className="link b pointer"
                                    onClick={this.addGiftMessage}
                                >
                                    Edit
                                </span>
                            </span>
                        </div>
                    </div>
                )}

                {store.checkout.cstep >= ICheckoutStep.shipping_methods && (
                    <div className="row">
                        <div className="col-12 mt-2">
                            {!this.editNoteGift && !store.uiCheckout.processing && !this.editNoteOrder && (
                                <div className="text-left notes-trigger">
                                    {store.checkout.notes_gift.length <= 0 && (
                                        <span className="pad-right">
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-light"
                                                onClick={this.addGiftMessage}
                                            >
                                                {store.checkout.notes_gift.length > 0 ? 'Edit' : 'Add'} Gift Message
                                            </button>
                                        </span>
                                    )}
                                    {store.checkout.notes_customer.length <= 0 && (
                                        <button
                                            type="button"
                                            className={store.checkout.isMyFrames ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-light'}
                                            onClick={this.addOrderNote}
                                        >
                                            {store.checkout.notes_customer.length > 0 ? 'Edit' : 'Add'} Order Note
                                        </button>
                                    )}
                                </div>
                            )}
                            {this.editNoteGift && (
                                <div className="gift-message">
                                    <hr />
                                    <div className="row">
                                        <div className="col-12 col-md-6">
                                            <span className="b">Gift Message</span>
                                        </div>
                                        <div className="col-12 col-md-6 text-right">
                                            <select
                                                name="gift-message-select"
                                                className="form-control"
                                                aria-label="Select gift message"
                                                value={store.checkout.giftMessageId}
                                                onChange={this.changeGiftMessage}
                                            >
                                                {store.checkout.giftMessages.map((o, i) => (
                                                    <option
                                                        key={i}
                                                        value={o.GiftMessageID}
                                                    >
                                                        {o.Name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="pad-top">
                                        <textarea
                                            name="gift-message"
                                            autoComplete="nope"
                                            className="form-control"
                                            aria-label="Gift message"
                                            maxLength={200}
                                            rows={3}
                                            value={store.checkout.notes_gift}
                                            onChange={e => (store.checkout.notes_gift = e.target.value)}
                                        />
                                    </div>
                                    <div
                                        className="pad-top"
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            marginTop: 4,
                                        }}
                                    >
                                        <div>
                                            <div style={{paddingLeft: 6}}>{store.checkout.notes_gift != undefined ? `${store.checkout.notes_gift.length.toString()}/200` : ''}</div>
                                        </div>
                                        <div>
                                            <button
                                                type="button"
                                                className="btn btn-light"
                                                onClick={() => (this.editNoteGift = false)}
                                                aria-label="Cancel editing gift message"
                                            >
                                                Cancel
                                            </button>
                                            <span className="pad-left">
                                                <button
                                                    type="button"
                                                    className="btn btn-light"
                                                    onClick={this.saveNotes}
                                                    aria-label="Save gift message"
                                                >
                                                    Save
                                                </button>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {this.editNoteOrder && (
                                <div className="order-note">
                                    <hr />
                                    <div className="row">
                                        <div className="col-12">
                                            <span className="b">Order Note</span>
                                        </div>
                                    </div>
                                    <div className="pad-top">
                                        <textarea
                                            name="order-note"
                                            autoComplete="off"
                                            className="form-control"
                                            aria-label="Order note"
                                            maxLength={5000}
                                            rows={3}
                                            value={store.checkout.notes_customer}
                                            onChange={e => (store.checkout.notes_customer = e.target.value)}
                                        />
                                    </div>
                                    <div
                                        className="pad-top"
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            marginTop: 4,
                                        }}
                                    >
                                        <div>
                                            <div style={{paddingLeft: 6}}>{store.checkout.notes_customer != undefined ? `${store.checkout.notes_customer.length.toString()}/5000` : ''}</div>
                                        </div>
                                        <div>
                                            <button
                                                type="button"
                                                className="btn btn-light"
                                                onClick={() => (this.editNoteOrder = false)}
                                                aria-label="Cancel order note editing"
                                            >
                                                Cancel
                                            </button>
                                            <span className="pad-left">
                                                <button
                                                    type="button"
                                                    className="btn btn-deflightault"
                                                    onClick={this.saveNotes}
                                                >
                                                    Save
                                                </button>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

@observer
class ShippingReadOnly extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <div className={store.checkout.cstep === ICheckoutStep.shipping_methods ? 'shipping-read shipping-read-options' : 'shipping-read'}>
                    <ShippingAddrReadOnly hideEdit={false} />
                    {/* <div className='shipping-edit'>
                    {store.checkout.cstep === ICheckoutStep.shipping_methods && <span className='shipping-edit-button-2' onClick={() => store.moveStep(ICheckoutStep.shipping)}>Edit</span>}
                </div> */}
                    {store.checkout.cstep > ICheckoutStep.shipping_methods && <ShipMethods />}
                </div>
                {store.checkout.cstep === ICheckoutStep.shipping_methods && <ShipMethods />}
                {store.checkout.cstep > ICheckoutStep.shipping_methods && <OrderNotes />}
            </div>
        );
    }
}

@observer
class ShippingComponent extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div id="c-shipping">
                <div
                    className="checkout-header"
                    style={{marginTop: store.checkout.cstep > ICheckoutStep.checkout ? 12 : 0, color: Portal?.PortalID === 3 ? '#33393a' : '', backgroundColor: Portal?.PortalID === 3 ? '#edece9' : ''}}
                >
                    {store.checkout.cstep > ICheckoutStep.checkout && !store.uiCheckout.processing && (
                        <span>
                            2. Shipping
                            {store.checkout.cstep >= ICheckoutStep.shipping_methods && (
                                <button
                                    className="shipping-edit-btn-header text-btn text-uppercase"
                                    onClick={() => store.moveStep(ICheckoutStep.shipping)}
                                    type="button"
                                    aria-label="Edit shipping information"
                                >
                                    Edit
                                </button>
                            )}
                            {store.checkout.cstep > ICheckoutStep.oci && store.checkout.cstep < ICheckoutStep.shipping_methods && (
                                <span
                                    className="fas fa-caret-down"
                                    aria-hidden={true}
                                    style={{
                                        fontSize: 20,
                                        paddingRight: 12,
                                        marginTop: 14,
                                        float: 'right',
                                        color: '#FFF',
                                    }}
                                />
                            )}
                        </span>
                    )}
                </div>

                {store.checkout.cstep >= ICheckoutStep.shipping && (
                    <div className="shipping">
                        <div className="checkout-padding checkout-border">
                            {store.checkout.cstep === ICheckoutStep.shipping && <ShippingAddrEdit />}

                            {store.checkout.ship.addr.country.value !== 'US' && (
                                <div
                                    className=""
                                    style={{marginTop: 12, marginBottom: 12}}
                                >
                                    <span style={{paddingRight: 4}}>
                                        <i className="fas fa-exclamation-triangle"></i>
                                    </span>
                                    On international orders, your packages may be subject to the customs fees and import duties of the country to which your order ships. These charges are always the recipient's responsibility, and are not included in shipping charges. Contact your local customs
                                    office for details.
                                </div>
                            )}

                            {store.checkout.cstep >= ICheckoutStep.shipping_methods && <ShippingReadOnly />}
                            {store.checkout.cstep === ICheckoutStep.shipping_correction && <ShippingCorrection />}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
export default ShippingComponent;
